<mat-card appearance="filled" class="container mat-elevation-z8" fxFlex="100%">
  <mat-card-title fxLayout="row" fxLayoutAlign="start center">
    <span class="header-text">{{ titleService.getBaseTitle() }}</span>
  </mat-card-title>

  <mat-card-content>
    @if (dataTable) {
      <form [formGroup]="dataTable.filter" fxLayout="row wrap" fxLayoutGap="10px">
        <mat-form-field color="accent" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Search</mat-label>
          <input matInput formControlName="filter">
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </form>
    }

    <mat-table #table [dataSource]="dataTable" matSort matSortActive="email" matSortDirection="asc" matSortDisableClear>

      <ng-container matColumnDef="email">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Email</mat-header-cell>
        <mat-cell *matCellDef="let user" class="no-wrap">
          <a routerLink="/users/{{user.id}}" class="no-wrap">{{ user.email }} </a>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="firstName">
        <mat-header-cell *matHeaderCellDef mat-sort-header> First Name</mat-header-cell>
        <mat-cell *matCellDef="let user" class="no-wrap">{{ user.firstName }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="lastName">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Last Name</mat-header-cell>
        <mat-cell *matCellDef="let user" class="no-wrap">{{ user.lastName }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="organization.name">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Organization</mat-header-cell>
        <mat-cell *matCellDef="let user"> {{ user.organization?.name }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="store.name">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Home Store</mat-header-cell>
        <mat-cell *matCellDef="let user"> {{ user.store?.name }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="lastSignInAt">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Last Sign In</mat-header-cell>
        <mat-cell *matCellDef="let user"> {{ user.lastSignInAt | date: 'short' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="roles">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Roles</mat-header-cell>
        <mat-cell *matCellDef="let user">
          <div>{{ user.roles?.join(', ') | titlecase }}</div>
          @if (user.roles.length === 0) {
            <span>N/A</span>
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="addOrDelete">
        <mat-header-cell *matHeaderCellDef>
          <button mat-icon-button (click)="openCreate()">
            <mat-icon>add</mat-icon>
          </button>
        </mat-header-cell>
        <mat-cell *matCellDef="let user">
          @if (canEditOrDelete(user)) {
            <span>
              @if (this.roleOptions?.length > 0) {
                <span>
                  <button mat-icon-button (click)="openEdit(user)" class="org-table-icon">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button mat-icon-button (click)="deleteUser(user)" class="org-table-icon">
                    <mat-icon>delete</mat-icon>
                  </button>
                </span>
              }
            </span>
          }

        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="dataTable?.displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: dataTable?.displayedColumns"></mat-row>
    </mat-table>
    <mat-paginator [pageSize]="50" [pageSizeOptions]="[25, 50, 100, 250]" showFirstLastButtons></mat-paginator>
  </mat-card-content>
</mat-card>
